import type * as React from 'react'
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu'
import { cn } from '../../lib/utils.ts'

export const DropdownMenu = DropdownMenuPrimitive.Root
export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger

export function DropdownMenuContent({ className, ...props }: React.ComponentProps<typeof DropdownMenuPrimitive.Content>) {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        sideOffset={4}
        className={cn(
          'z-50 min-w-56 overflow-hidden rounded-[var(--radius-lg)] border border-[var(--border)]',
          'bg-[var(--popover)] p-1 text-[var(--popover-foreground)] shadow-lg',
          className,
        )}
        {...props}
      />
    </DropdownMenuPrimitive.Portal>
  )
}

export function DropdownMenuItem({ className, ...props }: React.ComponentProps<typeof DropdownMenuPrimitive.Item>) {
  return (
    <DropdownMenuPrimitive.Item
      className={cn(
        'flex cursor-pointer select-none flex-col items-start gap-0.5 rounded-[var(--radius-md)] px-2.5 py-2',
        'text-[length:var(--text-sm)] outline-none data-[highlighted]:bg-[var(--muted)]',
        className,
      )}
      {...props}
    />
  )
}

export function DropdownMenuLabel({ className, ...props }: React.ComponentProps<typeof DropdownMenuPrimitive.Label>) {
  return (
    <DropdownMenuPrimitive.Label
      className={cn(
        'px-2.5 py-1.5 text-[length:var(--text-2xs)] font-semibold uppercase',
        'tracking-[var(--tracking-label)] text-[var(--muted-foreground)]',
        className,
      )}
      {...props}
    />
  )
}
